export const ZOOM_IN = 17

export const ZOOM_OUT = 14

export const COLLECTION_NAMES_LIST = ['comercial', 'lugares', 'gente']
